module.exports = __webpack_public_path__ + "VAGRoundedStd-Thin.df4ea977bd8175e1fae4.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.woff2
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.woff2
// module chunks = styles